import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

export const getMeta = () => client.get("/meta").then((r) => r.data);

export const searchByName = (q, type, key) =>
  client
    .get("/search/name", { params: { q, type: type || undefined, key: key || undefined } })
    .then((r) => r.data);

export const searchByNotes = (q, type, key) =>
  client
    .get("/search/notes", { params: { q, type: type || undefined, key: key || undefined } })
    .then((r) => r.data);

export const searchByLink = (url) =>
  client.get("/search/link", { params: { url } }).then((r) => r.data);

export const getRecordingTrack = (id, n) => client.get(`/recordings/${id}/tracks/${n}`).then((r) => r.data);

export const getFoundLinks = (tuneId) => client.get(`/found-links/${tuneId}`).then((r) => r.data);

export const searchByFilter = (type, key) =>
  client
    .get("/search/filter", { params: { type: type || undefined, key: key || undefined } })
    .then((r) => r.data);

export const searchByFame = (payload) =>
  client.post("/search/fame", payload).then((r) => r.data);

export const getTune = (id) => client.get(`/tunes/${id}`).then((r) => r.data);

export const verifyRarity = (id) =>
  client.get(`/tunes/${id}/verify-rarity`).then((r) => r.data);

export const getCachedAiAnalysis = (id) =>
  client.get(`/tunes/${id}/ai-analysis`).then((r) => r.data);

export const getAiAnalysis = (id, refresh = false) =>
  client
    .post(`/tunes/${id}/ai-analysis`, null, { params: { refresh } })
    .then((r) => r.data);

export const forceRefresh = () => client.post("/admin/refresh").then((r) => r.data);
export const refreshStatus = () =>
  client.get("/admin/refresh/status").then((r) => r.data);

// ---- auth
export const authApi = {
  me: () => client.get("/auth/me").then((r) => r.data),
  exportData: () => client.get("/auth/export").then((r) => r.data),
  deleteAccount: () => client.delete("/auth/account").then((r) => r.data),
  session: (session_id) => client.post("/auth/session", { session_id }).then((r) => r.data),
  logout: () => client.post("/auth/logout").then((r) => r.data),
};

// ---- payments
export const paymentsApi = {
  checkout: (lookup_key) =>
    client
      .post("/payments/checkout", { lookup_key, origin_url: window.location.origin })
      .then((r) => r.data),
  status: (session_id) => client.get(`/payments/status/${session_id}`).then((r) => r.data),
  history: () => client.get("/payments/history").then((r) => r.data),
  portal: () =>
    client.post("/payments/portal", { origin_url: window.location.origin }).then((r) => r.data),
  cancel: () => client.post("/payments/cancel").then((r) => r.data),
  gift: (email, plan, calls) =>
    client.post("/admin/gift", { email, plan, calls }).then((r) => r.data),
};

// ---- admin
export const flagsApi = {
  list: () => client.get("/flags").then((r) => r.data),
  set: (flag) => client.post("/flags", flag).then((r) => r.data),
  clear: (key) => client.delete(`/flags/${encodeURIComponent(key)}`).then((r) => r.data),
  setLabels: (labels) => client.put("/flags/labels", { labels }).then((r) => r.data),
};

export const rankingApi = {
  get: (tuneId) => client.get(`/tunes/${tuneId}/ranking-vote`).then((r) => r.data),
  vote: (tuneId, vote) =>
    client.post(`/tunes/${tuneId}/ranking-vote`, { vote }).then((r) => r.data),
};

export const adminApi = {
  stats: () => client.get("/admin/stats").then((r) => r.data),
  users: () => client.get("/admin/users").then((r) => r.data),
  transactions: () => client.get("/admin/transactions").then((r) => r.data),
  getSettings: () => client.get("/admin/settings").then((r) => r.data),
  updateSettings: (patch) => client.put("/admin/settings", patch).then((r) => r.data),
  fameDistribution: () => client.get("/admin/fame-distribution").then((r) => r.data),
  stripe: () => client.get("/admin/stripe").then((r) => r.data),
  registerWebhook: (base_url) =>
    client.post("/admin/stripe/webhook", { base_url }).then((r) => r.data),
  deleteWebhook: (id) => client.delete(`/admin/stripe/webhook/${id}`).then((r) => r.data),
  syncCatalog: () => client.post("/admin/stripe/sync-catalog").then((r) => r.data),
  exportAiCache: () => client.get("/admin/ai-cache/export").then((r) => r.data),
  importAiCache: (analyses, overwrite = false) =>
    client.post("/admin/ai-cache/import", { analyses, overwrite }).then((r) => r.data),
  socialCaption: (kind, context) =>
    client.post("/admin/social/caption", { kind, context }).then((r) => r.data),
};

// ---- favourites (server-synced when signed in)
export const favouritesApi = {
  list: () => client.get("/favourites").then((r) => r.data),
  add: (fav) => client.post("/favourites", fav).then((r) => r.data),
  remove: (key) => client.delete(`/favourites/${encodeURIComponent(key)}`).then((r) => r.data),
};
